import { render, staticRenderFns } from "./Paket.vue?vue&type=template&id=787593d8&"
import script from "./Paket.vue?vue&type=script&lang=js&"
export * from "./Paket.vue?vue&type=script&lang=js&"
import style0 from "./Paket.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports